import component from './Link'

export default component
export * from './Link'
